export default __webpack_public_path__ + "static/media/quickly3.80744c29.png";